export default __webpack_public_path__ + "static/media/sticker-h.6ba55372.png";